import _ from "lodash";
import React from "react";
import { scaleDiverging, scaleThreshold } from "d3-scale";
import { interpolatePuOr } from "d3-scale-chromatic";
import PuOrImage from "./PuOr.png";
import sequentialPaletteImage from "./sequentialPalette.png";
import sequentialPaletteInvertedImage from "./sequentialPalette-inverted.png";

const DEFAULT_COLOR = "#FFFFFF";

function sequentialPalette(min, max) {
	const d = (max - min) / 7;
	return scaleThreshold()
		.range([
			"#8ccd9d",
			"#80b29c",
			"#7a9693",
			"#7a7a82",
			"#7d5d66",
			"#813c3f",
			"#820003",
		])
		.domain([
			min + d * 1,
			min + d * 2,
			min + d * 3,
			min + d * 4,
			min + d * 5,
			min + d * 6,
		]);
}

function sequentialInvertedPalette(max, min) {
	const d = (max - min) / 7;
	return scaleThreshold()
		.range([
			"#820003",
			"#813c3f",
			"#7d5d66",
			"#7a7a82",
			"#7a9693",
			"#80b29c",
			"#8ccd9d",
		])
		.domain([
			min + d * 1,
			min + d * 2,
			min + d * 3,
			min + d * 4,
			min + d * 5,
			min + d * 6,
		]);
}

export function getColorFeature(value, paletteType, min, max) {
	if (value === 0 || _.isNil(value)) {
		return DEFAULT_COLOR;
	} else {
		return getScaleValue(paletteType, min, max, value);
	}
}

export function getScaleValue(paletteType, min, max, value) {
	const middle = min / 2;
	const range = middle + min;
	const shouldUSeHundredNeutralValue = min < 100 && max > 100;
	const middleValue = shouldUSeHundredNeutralValue ? 100 : range;
	const divergentScale = scaleDiverging(interpolatePuOr).domain([
		min,
		middleValue,
		max,
	]);
	const sequentialScale = sequentialPalette(min, max);
	const sequentialScaleInverted = sequentialInvertedPalette(max, min);

	switch (paletteType) {
		case "SEQUENTIAL":
			return sequentialScale(value);
		case "INVERTED_SEQUENTIAL":
			return sequentialScaleInverted(value);
		case "DIVERGENT":
			return divergentScale(value);
		default:
			return divergentScale(value);
	}
}

const DIVERGENT_ITEM = {
	upText: "Más alto",
	middleText: "Promedio",
	downText: "Más bajo",
};

const SEQUENTIAL_ITEM = {
	upText: "Más bajo",
	middleText: "Promedio",
	downText: "Más alto",
};

const INVERTED_SEQUENTIAL_ITEM = {
	upText: "Más alto",
	middleText: "Promedio",
	downText: "Más bajo",
};

export function buildArrowItem(paletteType) {
	switch (paletteType) {
		case "SEQUENTIAL":
			return SEQUENTIAL_ITEM;
		case "INVERTED_SEQUENTIAL":
			return INVERTED_SEQUENTIAL_ITEM;
		case "DIVERGENT":
			return DIVERGENT_ITEM;
		default:
			return DIVERGENT_ITEM;
	}
}

export function getImage(paletteType) {
	const props = {
		style: {
			position: "relative",
			left: -30,
		},
		className: "w-10 h-24",
	};

	switch (paletteType) {
		case "SEQUENTIAL":
			return (
				<img src={sequentialPaletteImage} {...props} alt="sequential Scale" />
			);
		case "INVERTED_SEQUENTIAL":
			return (
				<img
					src={sequentialPaletteInvertedImage}
					{...props}
					alt="sequential Inverted"
				/>
			);
		case "DIVERGENT":
			return <img src={PuOrImage} {...props} alt="PuOr Scale" />;
		default:
			return <img src={PuOrImage} {...props} alt="PuOr Scale" />;
	}
}



// WEBPACK FOOTER //
// ./src/components/map/functions.js